module.exports = __webpack_public_path__ + "f2276b01517fdae43aeb92d8feafef.png";